import React from "react";
import { Formik, Form, useField } from "formik";
import { TextField } from "@material-ui/core";
import * as yup from "yup";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { userLogin } from "../actions/AuthActions";
import StudentService from "../services/StudentService";
import { API_ROOT, awaitableRootSchoolCode } from "../apis/ApiConfig";
import history from "../history";
import AuthService from "../services/AuthService";

const MyTextField = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  var errorText = meta.error && meta.touched ? meta.error : "";

  return (
    <TextField
      inputProps={{ "aria-label": label }}
      margin={"dense"}
      size="small"
      variant="outlined"
      label={label}
      disabled={props.disabled}
      type={props.type}
      {...field}
      helperText={errorText}
      error={!!errorText}
    />
  );
};

export const LoginForm = (props) => {
  var validationSchema = yup.object({
    username: yup
      .string()
      .required("Username is a required field")
      .matches(
        /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
        "Must be a valid email. "
      ),

    password: yup.string().required("Password is a required field"),
  });

  return (
    <>
      <i className="far fa-play-circle fa-4x" />
      <h4>User Login</h4>
      <Formik
        initialValues={{
          username: "",
          password: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(data, { setSubmitting }) => {
          setSubmitting(true);
          props.userLogin(data.username, data.password, async (uuid) => {
            let forgotPasswordUrl = window.location.href.replace('login', 'forgotPassword');

            //this command sets the cookie properly
            await AuthService.studentAccountLookup({
              Username: data.username,
              SchoolCode: await awaitableRootSchoolCode(),
              PURL: API_ROOT,
            });

            StudentService.SendResetPasswordEmail(
              uuid,
              data.username,
              await awaitableRootSchoolCode(),
              forgotPasswordUrl
            ).then((x) => {
              if (x) {
                history.push('/newAccountPasswordReset');
              }
            });
          }, async () => {
            setSubmitting(false);
          })
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <div>
              <MyTextField
                label="Username (email)"
                name="username"
                type="input"
              ></MyTextField>
            </div>
            <div>
              <MyTextField
                label="Password"
                name="password"
                type="password"
              ></MyTextField>
            </div>
            <div>
              <Link
                to={() =>
                  props.domain
                    ? `/forgotPassword/${props.domain}`
                    : "/forgotPassword"
                }
              >
                Forgot Password
              </Link>
            </div>
            <div>
              <Button
                className="btn-success"
                disabled={isSubmitting}
                type="submit"
              >
                Submit
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default connect(null, { userLogin })(LoginForm);
